let crypto = require('crypto');
let querystring = require('querystring');


function nonce(len) {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < len; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

function forceUnicodeEncoding(string) {
    return decodeURIComponent(encodeURIComponent(string));
}

function created_signed_embed_url(options) {
    // looker options
    let secret = options.secret;
    let host = options.host;

    // user options
    let json_external_user_id = JSON.stringify(options.external_user_id);
    let json_permissions = JSON.stringify(options.permissions);
    let json_models = JSON.stringify(options.models);
    let json_access_filters = JSON.stringify(options.access_filters);
    let json_user_attributes = JSON.stringify(options.user_attributes || {});

    // url/session specific options
    let embed_path = '/login/embed/' + encodeURIComponent(options.embed_url);
    let json_session_length = JSON.stringify(options.session_length);
    let json_force_logout_login = JSON.stringify(options.force_logout_login);
    let json_group_ids = JSON.stringify(options.group_ids);

    // computed options
    let json_time = JSON.stringify(Math.floor((new Date()).getTime() / 1000));
    let json_nonce = JSON.stringify(nonce(16));

    // compute signature
    let string_to_sign = "";
    string_to_sign += host + "\n";
    string_to_sign += embed_path + "\n";
    string_to_sign += json_nonce + "\n";
    string_to_sign += json_time + "\n";
    string_to_sign += json_session_length + "\n";
    string_to_sign += json_external_user_id + "\n";
    string_to_sign += json_permissions + "\n";
    string_to_sign += json_models + "\n";
    string_to_sign += json_group_ids + "\n";
    string_to_sign += json_user_attributes + "\n";
    string_to_sign += json_access_filters;

    let signature = crypto.createHmac('sha1', secret).update(forceUnicodeEncoding(string_to_sign)).digest('base64').trim();

    // construct query string
    let query_params = {
        nonce: json_nonce,
        time: json_time,
        session_length: json_session_length,
        external_user_id: json_external_user_id,
        permissions: json_permissions,
        models: json_models,
        access_filters: json_access_filters,
        force_logout_login: json_force_logout_login,
        group_ids: json_group_ids,
        user_attributes: json_user_attributes,
        signature: signature
    };
    var query_string = querystring.stringify(query_params);
    return host + embed_path + '?' + query_string;
}

export function generateURL(data, user) {
    let ONE_HOUR = 60 * 60;
    let url_data = {
        host: process.env.REACT_APP_LOOKER_URL_HOST,
        secret: process.env.REACT_APP_LOOKER_EMBED_SECRET,
        external_user_id: data.user_id,
        group_ids: [6],
        permissions: ['access_data', 'download_without_limit', 'schedule_look_emails', 'see_drill_overlay', 'see_looks', 'see_user_dashboards', 'send_to_integration'],
        models: ['Slice', 'japan_clickstream'],
        access_filters: {},
        session_length: ONE_HOUR,
        user_attributes : user.user_attributes,
        embed_url: "/embed/dashboards/" + data.dashboard_id + "?embed_domain=" + process.env.REACT_APP_EMBED_DOMAIN + generateUrlFilters(data),
        force_logout_login: true
    };
    let url = created_signed_embed_url(url_data);
    return "https://" + url;
}

export function generateUrlFilters(data){
    if (data.override_filters === true){
        let url = new URL(data.object.absoluteUrl);
        let filters = "&filter_config=" + url.searchParams.get("filter_config");
        return filters;
    }
    else return "";
}

